<template>
  <span>
    <a
      v-if="linkTo"
      href="javascript:;"
      class="el-route-link"
      @click="link">
      <slot></slot>
    </a>
    <a
      v-else
      href="javascript:;"
      class="el-route-link">
      <slot></slot>
    </a>
  </span>
</template>
<script>
export default {
  name: 'LinkRoute',
  props: {
    linkTo: {
      type: String,
      default: ''
    }
  },
  methods: {
    link() {
      this.$router.push(this.linkTo)
    }
  }
}
</script>
<style lang="stylus" scoped>
.el-route-link {
  color: #409EFF;
  text-decoration: none;
}
</style>
